<div class="filter">
  <button class="_btn black medium-plus" (click)="openFilterModal()">
    {{ title }}
  </button>
  @if (appliedFilters.length > 0) {
    <div class="filter-applied">
      @for (filter of appliedFilters; track filter) {
        <div class="filter-chip">
          <div class="filter-wrapper">
            <span class="label">{{ filter.filterLabel }}:</span>
            <span class="value">{{ filter.label }}</span>
          </div>

          <button class="remove-filter" (click)="removeFilter(filter)">
            <img
              [ngSrc]="'assets/img/icons/close-new.svg'"
              width="10"
              height="10"
              alt=""
            />
          </button>
        </div>
      }
    </div>
  }
</div>
